import { render } from "./SharedRecordings.vue?vue&type=template&id=5a4f9062&scoped=true"
import script from "./SharedRecordings.vue?vue&type=script&lang=js"
export * from "./SharedRecordings.vue?vue&type=script&lang=js"

import "./SharedRecordings.vue?vue&type=style&index=0&id=5a4f9062&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4f9062"]])

export default __exports__